import { render, staticRenderFns } from "./UITextArea.vue?vue&type=template&id=36705292&scoped=true"
import script from "./UITextArea.vue?vue&type=script&lang=js"
export * from "./UITextArea.vue?vue&type=script&lang=js"
import style0 from "./UITextArea.vue?vue&type=style&index=0&id=36705292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36705292",
  null
  
)

export default component.exports